let videoObs = null;
let videoObs2 = null;


// 控制视频暂停播放
export function videoObserver(id, threshold = 0.5) {
  // 防止在非浏览器环境执行
  if (typeof window === 'undefined' || !window.IntersectionObserver) return;
  if (videoObs) {
    videoObs.disconnect() // 先清除已存在的
  }
  // 获取视频元素
  const video = document.getElementById(id);
  videoObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
          // 判断视频元素是否进入可视区域
          if (entry.isIntersecting) {
              // 进入可视区域：播放视频
              video.play().catch(error => {
                  console.log('自动播放被阻止:', error);
              });
          } else {
              video.pause();
          }
      });
  }, {
      // 配置选项
      threshold, // 阈值：默认50% 可见时触发
  });

  videoObs.observe(video);

  return videoObs;
}

export function destroyVideoObserver() {
  if (videoObs) {
    videoObs.disconnect()
    videoObs = null
  }
}


export function videoObserverByClass(className, threshold = 0.5) {
  // 防止在非浏览器环境执行
  if (typeof window === 'undefined' || !window.IntersectionObserver) return;
  if (videoObs2) {
    videoObs2.disconnect() // 先清除已存在的
  }
  // 获取所有匹配的视频元素
  const videos = document.getElementsByClassName(className);
  
  // 如果没有找到元素，直接返回
  if (!videos || videos.length === 0) return;

  videoObs2 = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const targetVideo = entry.target;
        // 确保目标是视频元素且具备播放/暂停能力
          if (targetVideo && typeof targetVideo.play === 'function') {
            if (entry.isIntersecting) {
              // 进入可视区域：播放视频
              targetVideo.play().catch(error => {
                  console.log('自动播放被阻止:', error);
              });
            } else {
              // 离开可视区域：暂停视频
              targetVideo.pause();
            }
          }
      });
  }, {
      // 配置选项
      threshold, // 阈值：默认50% 可见时触发
  });

  // 遍历所有视频元素，分别进行观察
  Array.from(videos).forEach(video => {
      videoObs2.observe(video);
  });

  return videoObs2;
}

export function destroyVideoObserverByClass() {
  if (videoObs2) {
    videoObs2.disconnect()
    videoObs2 = null
  }
}